import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { Query } from 'graphql/generated/graphqlTypes';
import { GET_CURRENT_TENANT } from 'graphql/queries';
import { useEffect } from 'react';
import { setCurrentTenantAction } from 'state/actions/currentTenant';
import { currentTenantVar } from 'state/vars';
import { BaseHookProps } from '../shared/types';

const useCurrentTenant = ({ handleFetchError }: BaseHookProps) => {
  const currentTenant = useReactiveVar(currentTenantVar);

  const [getCurrentTenant, { loading, data, error }] =
    useLazyQuery<Pick<Query, 'getCurrentTenant'>>(GET_CURRENT_TENANT);

  useEffect(() => {
    if (data) setCurrentTenantAction(data.getCurrentTenant);
  }, [data]);

  useEffect(() => {
    if (error) handleFetchError('Error while fetching tenant registration info');
  }, [error]);

  useEffect(() => {
    if (currentTenant === null) getCurrentTenant();
  }, [getCurrentTenant]);

  return {
    getCurrentTenant,
    currentTenant,
    loading
  };
};

export default useCurrentTenant;
